import React from 'react';

function DrillCard({ drill }) {
  const renderComplexityBadge = (c) => {
    const level = parseInt(c, 10);
    const base = { color: 'white' };
    if (level === 1) return <span className="badge ms-2" style={{ ...base, backgroundColor: '#198754' }} title="C1 · semplice">C1</span>; // verde
    if (level === 2) return <span className="badge ms-2" style={{ ...base, backgroundColor: '#fd7e14' }} title="C2 · medio">C2</span>; // arancio
    if (level === 3) return <span className="badge ms-2" style={{ ...base, backgroundColor: '#dc3545' }} title="C3 · medio-alto">C3</span>; // rosso
    if (level === 4) return <span className="badge ms-2" style={{ ...base, backgroundColor: '#6f42c1' }} title="C4 · alto">C4</span>; // viola
    return <span className="badge bg-secondary ms-2">C{c}</span>;
  };

  return (
    <div className="col-md-4 mb-3">
      <div className="card shadow-sm" style={{ width: "400px", borderRadius: "12px" }}>
        <div className="card-body">
          <h5 className="card-title">{drill.title}</h5>
          <p className="card-text">
            <strong>Formato: </strong> {drill.format} <br />
            <strong>Obiettivi: </strong>{' '}
            {((Array.isArray(drill.primary_objectives) && drill.primary_objectives.length > 0) || (Array.isArray(drill.secondary_objectives) && drill.secondary_objectives.length > 0)) ? (
              <>
                {(Array.isArray(drill.primary_objectives) ? drill.primary_objectives : []).map((obj, idx) => (
                  <span key={`primary-${idx}`} className="badge bg-primary text-white me-1">{obj}</span>
                ))}
                {(Array.isArray(drill.secondary_objectives) ? drill.secondary_objectives : []).map((obj, idx) => (
                  <span key={`secondary-${idx}`} className="badge bg-success text-white me-1">{obj}</span>
                ))}
              </>
            ) : "—"} <br />
            <strong>Durata: </strong> {drill.duration_min} min <br />
            <strong>Vincoli: </strong> {(Array.isArray(drill.constraints) ? drill.constraints : []).join(", ") || "—"} <br />
          </p>
          <div className="mt-2">
            <strong>Età: </strong>{' '}
            {(Array.isArray(drill.age_categories) ? drill.age_categories : (drill.age_category ? [drill.age_category] : []))
              .map((cat, idx) => (
                <span key={idx} className={`badge ${cat === 'Tutte' ? 'bg-dark' : 'bg-secondary'} me-1`}>{cat}</span>
              ))}
          </div>
          <strong>Complessità: </strong>{renderComplexityBadge(drill.complexity)}
          <p className="mt-2">
            <strong>Palloni: </strong> {drill.balls ? drill.balls.length : 0}
          </p>
        </div>
      </div>
    </div>
  );
}

export default DrillCard;